import { render, staticRenderFns } from "./groupBuyProductManage.vue?vue&type=template&id=649689f0&scoped=true"
import script from "./groupBuyProductManage.vue?vue&type=script&lang=js"
export * from "./groupBuyProductManage.vue?vue&type=script&lang=js"
import style0 from "./groupBuyProductManage.vue?vue&type=style&index=0&id=649689f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649689f0",
  null
  
)

export default component.exports